module.exports = __webpack_public_path__ + "static/img/pokdeng.0843070.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/pokdeng.png
// module id = Fmuv
// module chunks = 1